module.exports = __webpack_public_path__ + "img/contactus-head.fed3f03e.png";